<template>
  <div class="case-detail-region-gene-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailRegionGene.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="data-container col-block" :style="{ flex: 1 }">
      <div class="data-title-container row-block">
        <div
          class="data-title"
          v-html="[
            regionData.region_classification,
            regionData.SV_type,
            [
              'chr' + regionData.SV_chrom,
              regionData.CytoBand
            ].map(v => '(' + v + ')').join('')
          ].join(' ')"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block width-full" :style="{ flex: 1 }">
        <regionGeneData
          v-bind="param"
        ></regionGeneData>
      </div>
    </div>
    <div :style="{ height: '0' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import regionGeneData from '../caseDetail/regionGeneData.vue'

export default {
  components: {
    regionGeneData
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    regionData () {
      return this.param.regionData
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailRegionGene.vue